import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import Transition from '../../../components/Transition/Transition';
import React, { useEffect, useMemo } from 'react';
import { closeModal } from '../../../components/Modal/modalReducer';
import { useDispatch, useSelector } from 'react-redux';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import SupplierDetailsForm from '../../Shared/CostManager/SupplierDetails/SupplierDetailsForm/SupplierDetailsForm';
import * as actions from '../../../store/actions';
import { getOpexContractDetails, getOpexSupplierDetails, updateOpexContractDetails } from '../../../store/actions';
import { getForm } from '../../Shared/CostManager/ContractDetails/ContractDetailsEdit/form';
import Supplier from '../../Shared/CostManager/ContractDetails/ContractDetailsEdit/Supplier';
import { toast } from 'react-toastify';

const OpexManagerEditModal = ({ data, assetId }) => {
  const supplier = useSelector((state) => state.opexManager.supplier);
  const contractDetails = useSelector((state) => state.opexManager.details);

  const dispatch = useDispatch();

  const [supplierForm, setSupplierForm] = React.useState({});
  const [contractDetailsForm, setContractDetailsForm] = React.useState({});

  const primaryContractDetails = useMemo(
    () => (!!contractDetails ? contractDetails[0] : null),
    [contractDetails]
  );

  useEffect(() => {
    dispatch(getOpexSupplierDetails(data.id));
    dispatch(getOpexContractDetails(data.id));
  }, [data]);

  useEffect(() => setSupplierForm(supplier), [supplier]);
  useEffect(() => {
    const primaryContractDetailsData = primaryContractDetails?.typedata ?
      JSON.parse(primaryContractDetails?.typedata) :
      {};

    setContractDetailsForm(!!primaryContractDetails ? getForm(primaryContractDetails, primaryContractDetailsData) : {})
  }, [primaryContractDetails]);

  const handleSave = () => {
    dispatch(actions.updateOpexSupplierDetails({ ...supplierForm, id: supplier.id }))
      .then(() => dispatch(actions.updateOpexContractDetails(primaryContractDetails.id, contractDetailsForm)))
      .then(() => dispatch(closeModal()))
      .then(() => toast.success('Opex Manager updated successfully'))
      .then(() => dispatch(actions.getOpexManager(assetId)));
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  return (
    <Dialog
      open
      onClose={handleCloseModal}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      maxWidth="md"
    >
      <Box bgcolor="#2C324D" p={2} display="flex" mb={2} color="white" alignItems="center">
        <DialogTitle id="alert-dialog-slide-title">Edit Opex Manager "{data.name}"</DialogTitle>
      </Box>
      <DialogContent>
        <Accordion
          defaultExpanded
          style={{ marginBottom: '20px' }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography style={{ marginRight: '20px' }}>Supplier Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <SupplierDetailsForm loading={false} details={supplier} formChanged={setSupplierForm} />
          </AccordionDetails>
        </Accordion>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography style={{ marginRight: '20px' }}>Contract Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Supplier form={contractDetailsForm} setForm={setContractDetailsForm} />
          </AccordionDetails>
        </Accordion>
      </DialogContent>
      <DialogActions>
        <Box p={2} display="flex" flexWrap="wrap">
          <Box ml={2} mr={2}>
            <Button onClick={handleCloseModal} color="secondary" variant="outlined">
              Cancel
            </Button>
          </Box>
          <Button
            onClick={handleSave}
            color="primary"
            variant="contained"
            disabled={
              !supplierForm?.companyname ||
              contractDetailsForm?.contractType !== 'Supplier' ||
              new Date(contractDetailsForm?.startdate).getTime() > new Date(contractDetailsForm?.enddate).getTime()
            }
          >
            Save
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default OpexManagerEditModal;
